import _ from 'underscore'
import initializers, { InjectView } from './initializers'

export default function(views) {
  new InjectView(views)
  _.each(initializers, (obj, className) => {
    new initializers[className]()
  })
}
